class URLService {
	public static readonly shared = new URLService();

	appendRoutePath = (route: string, path: string): string => {
		return ['', this.removeLeadingAndTrailing(route), this.removeLeadingAndTrailing(path)].join(
			'/',
		);
	};

	removeOneRoutePath = (haystack: string, needle: string = '/'): string => {
		const pathParts = haystack.split(needle).filter((segment) => segment !== '');
		pathParts.pop();
		return pathParts.join(needle);
	};

	isExternalLink = (value: string): boolean => {
		return value.startsWith('https://') || value.startsWith('http://');
	};

	private removeLeadingAndTrailing = (haystack: string, needle: string = '/'): string => {
		return haystack
			.split(needle)
			.filter((segment) => segment !== '')
			.join(needle);
	};
}

export default URLService.shared;
